const styles = (theme) => ({
    margin: {
        marginBottom: 20,
    },
    halfWidth: {
        width: '50%',
    },
});

export default styles;
